import React, { useState } from 'react';
import './SecretBoutiqueStyles.css';
import ClientsQueries from '../../requests/queries/ClientsQueries';
import ProtectedPage from './ProtectedPage';

const ClientSecret = () => {
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');

  const handleAccessCode = async (e) => {
    e.preventDefault();
    const code = e.target.accessCode.value;

    if(code.length < 4) {
      setError('Access code must be at least 4 characters');
      return;
    }

    const res = await ClientsQueries.validateAccessCode(code);

    if(res.status === 200) {
        window.location.href = '/shop';
      } else {
        setError(res.data.message);
      }
    }

    return (
      <ProtectedPage permissionsNeeded="client" needToBeAuthenticated={false} redirectPath="/client-auth">
        <div className="secret-access-container">
          <div className="secret-access-card">
            <div className="secret-logo">
              <img src="/patricians.png" width={'350px'} alt="Patricians Logo" className="logo-image" style={{ filter: 'invert(1)' }} />
            </div>
            
            <div className="secret-content">
              <h1>Secret Shop</h1>
              <p className="secret-subtitle">
                Exclusive access to the rarest and most limited products
              </p>
              
              <div className="secret-features">
                <div className="feature-item">
                  <i className="bi bi-lock-fill"></i>
                  <span>Ultra-limited products</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-star-fill"></i>
                  <span>Exclusive collections</span>
                </div>
                <div className="feature-item">
                  <i className="bi bi-gem"></i>
                  <span>Unique designs</span>
                </div>
              </div>

              <form onSubmit={handleAccessCode} className="access-form">
                <div className="form-group">
                  <label htmlFor="accessCode">Secret access code</label>
                  <input
                    type="text"
                    id="accessCode"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                    placeholder="Enter your access code"
                    className="access-input"
                    required
                  />
                </div>
                
                {error && (
                  <div className="error-message">
                    <i className="bi bi-exclamation-triangle"></i>
                    {error}
                  </div>
                )}
                
                <button type="submit" className="access-button">
                  <i className="bi bi-key"></i>
                  Access the secret shop
                </button>
              </form>

              <div className="secret-hint">
                <p style={{ color: '#fff' }}>
                  <i className="bi bi-info-circle" style={{ color: '#fff' }}></i>
                  You must have a valid access code to enter the secret shop.
                  These codes are distributed exclusively by the Patricians team.
                </p>
              </div>
            </div>
            <a href="/client/profile" className="secret-link-reset-password mt-3 pt-3" style={{ color: '#fff' }}>Back to client profile</a>
          </div>
        </div>
      </ProtectedPage>
    );
};

export default ClientSecret;
